import type { CreatePlanRequestPayload, CreatePlanResponse } from '@vy/api-definition';
import { CreatePlanResponseSchema } from '@vy/api-definition';
import { UseMutationOptions, useQueryClient } from 'react-query';
import { useMutation } from 'react-query';
import { getPrivateApi } from '../../services/api';
import { invalidatePlansQueries } from '../../utils/query-invalidation';

export function useCreatePlan(
  options?: UseMutationOptions<CreatePlanResponse, unknown, CreatePlanRequestPayload>,
) {
  const queryClient = useQueryClient();

  return useMutation(
    async (createPlanRequest) => {
      const api = getPrivateApi();
      const createPlanResponse = await api.createPlan({ createPlanRequest });

      return CreatePlanResponseSchema.parse(createPlanResponse);
    },
    {
      onSuccess: async () => {
        await invalidatePlansQueries(queryClient);
      },
      ...options,
    },
  );
}
